import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import 'primeflex/primeflex.css';
import App from "./App";
import { PrimeReactProvider } from "primereact/api";
import 'primereact/resources/themes/lara-light-blue/theme.css'; // Light tema
import 'primereact/resources/primereact.min.css'; // PrimeReact stil dosyası
import 'primeicons/primeicons.css'; // PrimeReact iconları
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PrimeReactProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </PrimeReactProvider>
);
